export default function Spinner({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center py-12 ${className}`}>
      <div className="w-8 h-8 border-3 border-inner-border border-t-blue-500 rounded-full animate-spin" />
    </div>
  );
}
